var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 2.33252C12.8773 2.33252 13.744 2.5054 14.5527 2.84033C15.3616 3.17536 16.0968 3.66659 16.7158 4.28564C17.3349 4.9047 17.8261 5.63989 18.1611 6.44873C18.4961 7.25746 18.6689 8.12417 18.6689 8.99951L18.6543 9.44189C18.5153 11.626 17.3621 13.4061 16.0205 14.7593C14.7687 16.0219 13.3744 16.8902 12.5586 17.3403L12.2461 17.5073V17.5083C12.1709 17.5476 12.0868 17.5679 12.002 17.5679L11.9385 17.564C11.8967 17.5589 11.8558 17.5485 11.8164 17.5337L11.7578 17.5083V17.5073L11.4453 17.3403C10.6296 16.8905 9.23525 16.022 7.9834 14.7593C6.55241 13.3158 5.33496 11.3866 5.33496 8.99951L5.34375 8.67139C5.38136 7.90814 5.54976 7.15625 5.84277 6.44873C6.1778 5.63989 6.66903 4.9047 7.28809 4.28564C7.90714 3.66659 8.64233 3.17536 9.45117 2.84033C10.1587 2.54732 10.9106 2.37892 11.6738 2.34131L12.002 2.33252ZM12.002 5.6665C11.1179 5.6665 10.2697 6.01697 9.64453 6.64209C9.01941 7.26721 8.66895 8.11546 8.66895 8.99951C8.66895 9.88357 9.01941 10.7318 9.64453 11.3569C10.2306 11.943 11.0129 12.2878 11.8369 12.3286L12.002 12.3325C12.886 12.3325 13.7343 11.9821 14.3594 11.3569C14.9845 10.7318 15.335 9.88357 15.335 8.99951C15.335 8.11546 14.9845 7.26721 14.3594 6.64209C13.7343 6.01697 12.886 5.6665 12.002 5.6665Z",
    fill: "#6B6B6B",
    stroke: "#6B6B6B",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.064 16.5C18.679 16.956 19.002 17.473 19.002 18C19.002 18.527 18.679 19.044 18.064 19.5C17.45 19.956 16.566 20.335 15.502 20.598C14.438 20.861 13.231 21 12.002 21C10.773 21 9.56595 20.861 8.50195 20.598C7.43795 20.335 6.55395 19.956 5.93995 19.5C5.32495 19.044 5.00195 18.527 5.00195 18C5.00195 17.473 5.32495 16.956 5.93995 16.5",
    stroke: "#6B6B6B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d3f150b3b6734e2cd84c389c9aba3826.svg";
export { ForwardRef as ReactComponent };